// /js/shared/main.js

import { initSharedUI } from '/js/shared/bootstrap/initSharedUI.js';

// Generic UI handlers, DOM events, context setup
initSharedUI();